export interface SearchResult {
  model: SearchResultModel;
  modelId: number;
  modelDescription: string;
  resultColumnDescription: string;
  resultColumnValue: string;
  icon: string;
}

export enum SearchResultModel {
  candidate = 1,
  requisition = 2
}
